import {
  AppShell,
  AppShellMobileNavigationTrigger,
  AssetWatchLogo,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  Sidebar,
  SidebarItem,
  Switch,
  TopBar,
  TopBarActions,
  TopBarContent,
  TopBarLeading,
  useTheme,
} from "@assetwatch/ui";
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { setFieldopsRouteSentryContext } from "../lib/sentry";

function FieldopsThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Switch
      aria-label="Use dark mode"
      checked={theme === "dark"}
      onCheckedChange={toggleTheme}
    />
  );
}

function FieldopsLayout() {
  const pathname = useRouterState({
    select: (state) =>
      state.resolvedLocation?.pathname ?? state.location.pathname,
  });

  useEffect(() => {
    setFieldopsRouteSentryContext(pathname);
  }, [pathname]);

  return (
    <AppShell>
      <TopBar>
        <TopBarLeading>
          <AppShellMobileNavigationTrigger />
          <span className="max-[599px]:hidden">
            <AssetWatchLogo aria-label="AssetWatch" />
          </span>
        </TopBarLeading>
        <TopBarContent>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Home</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </TopBarContent>
        <TopBarActions>
          <FieldopsThemeToggle />
        </TopBarActions>
      </TopBar>
      <Sidebar mobileHeaderLeading={<AssetWatchLogo aria-label="AssetWatch" />}>
        <SidebarItem
          itemId="home"
          label="Home"
          leading={{ type: "icon", name: "home" }}
          render={<Link to="/" />}
          selected={pathname === "/"}
        />
      </Sidebar>
      <Outlet />
    </AppShell>
  );
}

export const Route = createFileRoute("/_app")({
  component: FieldopsLayout,
});
